import React from "react";
import { LocationsParent } from "../components/locations/Locations";

const Locations = () => {
  return <LocationsParent />;
};

export default Locations;
